/**
 * @module HTML / Component - Popup
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/* tslint:disable:no-any no-use-before-declare */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Wove } from 'aspect.js/';
import { WIDGETS_CONSTANTS } from '@support/shared/widgets/constants/widgets.constants';

@Wove({ moduleName: WIDGETS_CONSTANTS.WIDGETS_MODULE })
@Component({
  selector: 'tmo-popup',
  templateUrl: './popup-component.html',
  styleUrls: ['../../../../../../style-sheets/components/popup.component.scss'],
})
export class PopupComponent implements OnInit, OnDestroy {
  /**
   * boolean to close popup
   */
  public popupClosed: boolean = false;
  /**
   * boolean to remove element
   */
  public removeElm: boolean = false;
  /**
   * variable to clear timeout
   */
  private fadeOutTimer: any;
  /**
   * variable to clear timeout
   */
  private removeElmTimer: any;
  /**
   * variable to store valule of message
   */
  @Input() public message: string;

  constructor() {
    this.fadeOut();
  }
  /**
   * Loads the initial data
   * @returns void
   */
  public ngOnInit(): void {}

  /**
   * Function to fadeout popup after 3 seconds
   * @returns void
   */
  public fadeOut(): void {
    if (this.popupClosed === false) {
      const time = 3000;
      this.fadeOutTimer = setTimeout(() => {
        this.popupClosed = true;
        this.removePopup();
      }, time);
    }
  }
  /**
   * Function to remove popup after popup fadeout
   * @returns void
   */
  public removePopup(): void {
    const removeElmTime = 500;
    this.removeElmTimer = setTimeout(() => {
      this.removeElm = true;
    }, removeElmTime);
  }
  /**
   * Function to close popup
   * @returns void
   */
  public closePopup(): void {
    this.popupClosed = true;
  }
  /**
   * Destroys the object when it goes out of scope
   * @returns void
   */
  public ngOnDestroy(): void {
    clearTimeout(this.fadeOutTimer);
    clearTimeout(this.removeElmTimer);
  }
}
